/**
 * 判断是否为空
 */
export function validatenull(val) {
  if (typeof val == "boolean") {
    return false;
  }
  if (typeof val == "number") {
    return false;
  }
  if (val instanceof Array) {
    if (val.length == 0) return true;
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === "{}") return true;
  } else {
    if (val == "null" || val == null || val == "undefined" || val == undefined || val == "")
      return true;
    return false;
  }
  return false;
}

// 地址二超长时把溢出部分顺延到地址三：优先在空格处折断，绝不从单词中间切断。
// 与后端识别 wapi/ai/analyze 的拆分口径保持一致（每行 ≤ 35 字符，超长单词整体保留一行）。
export const normalizeAddressOverflow = (form, limit = 35) => {
  if (!form) return form;

  const normalizeAddress = (data) => {
    if (!data) return;

    const addressTwo = data.address_two == null ? "" : String(data.address_two);
    const addressThree = data.address_three == null ? "" : String(data.address_three);

    // 地址二未超长：保持原样（仅确保 address_three 字段存在，避免后续读取 undefined）
    if (addressTwo.length <= limit) {
      if (data.address_three == null) data.address_three = addressThree;
      return;
    }

    // 超长：在 [0, limit] 内找最后一个空格作为折断点，保证不切断单词
    const head = addressTwo.slice(0, limit);
    const spaceIdx = head.lastIndexOf(" ");
    let first;
    let overflow;
    if (spaceIdx > 0) {
      first = addressTwo.slice(0, spaceIdx).trim();
      overflow = addressTwo.slice(spaceIdx + 1).trim();
    } else {
      // 前 limit 个字符内没有空格（第一个单词本身就超长）：整个单词不切断，
      // 找地址二里第一个空格，把这个超长单词整体留在地址二，其余顺延到地址三
      const firstSpace = addressTwo.indexOf(" ");
      if (firstSpace === -1) {
        first = addressTwo.trim();
        overflow = "";
      } else {
        first = addressTwo.slice(0, firstSpace).trim();
        overflow = addressTwo.slice(firstSpace + 1).trim();
      }
    }
    data.address_two = first;
    data.address_three = [overflow, addressThree].filter(Boolean).join(" ").trim();
  };

  normalizeAddress(form.send_data);
  normalizeAddress(form.receive_data);

  return form;
};

// 国家-城市数据格式转换
export const transformCountryCity = (list) => {
  // 定义转换后的数组
  let newCClist = [];
  // 遍历原始数据
  for (const item of list) {
    // 对于每个国家，创建一个新的选项对象
    const countryOption = {
      value: item.name,
      label: item.name,
      children: [],
    };
    // 遍历省份列表，并为每个省份创建子选项
    for (const province of item.province_list) {
      countryOption.children.push({
        value: province,
        label: province,
      });
    }
    // 将国家选项添加到转换后的数组
    newCClist.push(countryOption);
  }
  return newCClist;
};

// 获取州省列表
export const provinceListValue = (list, value) => {
  let prlist = list.find((item) => {
    return item.label == value;
  })
    ? list.find((item) => {
        return item.label == value;
      }).children
    : [];
  // 按 label 去重
  const seen = new Set();
  return prlist.filter((item) => {
    if (seen.has(item.label)) return false;
    seen.add(item.label);
    return true;
  });
};

// 下载-base64转excel
export const downloadBase64AsExcel = (base64String, fileName) => {
  let base64 = base64String.split("base64,")[1]; // 去除之前的数据
  // 解码Base64字符串
  const byteCharacters = atob(base64);
  // 创建一个8位的字符数组
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  // 将整数转换为typed array
  const byteArray = new Uint8Array(byteNumbers);
  // 创建一个blob对象
  const blob = new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // 创建URL对象
  const url = URL.createObjectURL(blob);

  // 创建下载链接
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "download.xlsx"; // 设置下载文件的默认文件名

  // 模拟点击
  document.body.appendChild(link);
  link.click();

  // 清理
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// 下载本地文件
export const createDownloadLink = (href, fileName) => {
  let link = document.createElement("a");
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// 货运等级
export const freightLevel = () => {
  return [50, 55, 60, 65, 70, 77.5, 85, 92.5, 100, 110, 125, 150, 175, 200, 250, 300, 400, 500];
};

// 将托盘类型转换成数组
export const JudgePalletTypeArr = () => {
  let objlistArr =
    window.localStorage.getItem("platform_name") == "Rapiddeals"
      ? JSON.parse(window.localStorage.getItem("RapiddealsPallet"))
      : JSON.parse(window.localStorage.getItem("Priority1Pallet"));
  let PalletTypeArr = [];

  for (var key in objlistArr) {
    let obj = {};
    obj.name = key;
    obj.id = objlistArr[key];
    PalletTypeArr.push(obj);
  }
  return PalletTypeArr;
};

// 将托盘类型转换成数组查找
export const JudgePalletTypeArrFind = (val) => {
  let objlistArr =
    window.localStorage.getItem("platform_name") == "Rapiddeals"
      ? JSON.parse(window.localStorage.getItem("RapiddealsPallet"))
      : JSON.parse(window.localStorage.getItem("Priority1Pallet"));
  let PalletTypeArr = [];

  for (var key in objlistArr) {
    let obj = {};
    obj.name = key;
    obj.id = objlistArr[key];
    PalletTypeArr.push(obj);
  }

  let batName = "";
  batName = PalletTypeArr.find((item) => {
    return item.id == val;
  })
    ? PalletTypeArr.find((item) => {
        return item.id == val;
      }).name
    : "";
  return batName;
};

// 商品单位
export const productUnit = () => {
  return [
    {
      value: 1,
      label: "BAG",
    },
    {
      value: 2,
      label: "BOXES",
    },
    {
      value: 3,
      label: "CARTONS",
    },
    {
      value: 4,
      label: "CASE",
    },
    {
      value: 5,
      label: "DRUMS",
    },
    {
      value: 6,
      label: "KEGS",
    },
    {
      value: 7,
      label: "REELS",
    },
    {
      value: 8,
      label: "ROLLS",
    },
    {
      value: 9,
      label: "TOTE",
    },
    {
      value: 10,
      label: "TUBES",
    },
    {
      value: 11,
      label: "PALLETS",
    },
    {
      value: 12,
      label: "PIECES",
    },
    {
      value: 13,
      label: "CYLINDERS",
    },
    {
      value: 14,
      label: "CRATE",
    },
  ];
};

// 商品单位查找
export const productUnitFind = (val) => {
  let list = [
    {
      value: 1,
      label: "BAG",
    },
    {
      value: 2,
      label: "BOXES",
    },
    {
      value: 3,
      label: "CARTONS",
    },
    {
      value: 4,
      label: "CASE",
    },
    {
      value: 5,
      label: "DRUMS",
    },
    {
      value: 6,
      label: "KEGS",
    },
    {
      value: 7,
      label: "REELS",
    },
    {
      value: 8,
      label: "ROLLS",
    },
    {
      value: 9,
      label: "TOTE",
    },
    {
      value: 10,
      label: "TUBES",
    },
    {
      value: 11,
      label: "PALLETS",
    },
    {
      value: 12,
      label: "PIECES",
    },
    {
      value: 13,
      label: "CYLINDERS",
    },
    {
      value: 14,
      label: "CRATE",
    },
  ];
  let unitName = "";
  unitName = list.find((item) => {
    return item.value == val;
  })
    ? list.find((item) => {
        return item.value == val;
      }).label
    : "";

  return unitName;
};

// 整车地址类型
export const addressType = (val) => {
  const list = [
    {
      value: "BUSINESS",
      label: "BUSINESS",
    },
    {
      value: "RESIDENTIAL",
      label: "RESIDENTIAL",
    },
    {
      value: "CONSTRUCTIONSITE",
      label: "CONSTRUCTIONSITE",
    },
    {
      value: "TRADESHOW",
      label: "TRADESHOW",
    },
  ];
  return list;
};

// 发货特殊需求
export const originSpeci = () => {
  const list = [
    {
      value: "1",
      label: "INSIDEPICKUP",
    },
    {
      value: "2",
      label: "LIFTGATEREQUIRED",
    },
  ];
  return list;
};

// 获取发货特殊需求的输入value 返回label
export const originSpeciFind = (values) => {
  let specList = [
    {
      value: "1",
      label: "INSIDEPICKUP",
    },
    {
      value: "2",
      label: "LIFTGATEREQUIRED",
    },
  ];

  // 将逗号隔开的字符串转换为数组
  const valueArray = values.split(',');

  return valueArray
    .map((value) => {
      // 确保 value 是字符串类型
      const item = specList.find((item) => item.value === value.trim());
      return item ? item.label : null;
    })
    .filter((label) => label !== null); // 过滤掉未找到的项
};

// 这个函数接受一个label数组，返回对应的value数组，然后转换成以逗号隔开的字符串
export const originSpeciFindValues = (labels) => {
  let specList = [
    {
      value: "1",
      label: "INSIDEPICKUP",
    },
    {
      value: "2",
      label: "LIFTGATEREQUIRED",
    },
  ];
  const values = labels
    .map((label) => {
      const item = specList.find((item) => item.label === label);
      return item ? item.value : null;
    })
    .filter((value) => value !== null); // 过滤掉未找到的项
  return values.join(","); // 将数组转换成以逗号隔开的字符串
};
// 收货特殊需求
export const destSpeci = () => {
  const list = [
    {
      value: "3",
      label: "INSIDEDELIVERY",
    },
    {
      value: "4",
      label: "LIFTGATEREQUIRED",
    },
    {
      value: "5",
      label: "APPOINTMENTFEE",
    },
  ];
  return list;
};
// 获取发货特殊需求的输入value 返回label
export const destSpeciFind = (values) => {
  let specList = [
    {
      value: "3",
      label: "INSIDEDELIVERY",
    },
    {
      value: "4",
      label: "LIFTGATEREQUIRED",
    },
    {
      value: "5",
      label: "APPOINTMENTFEE",
    },
  ];
  // 将逗号隔开的字符串转换为数组
  const valueArray = values.split(',');
  return valueArray
    .map((value) => {
      const item = specList.find((item) => item.value === value.toString());
      return item ? item.label : null;
    })
    .filter((label) => label !== null); // 过滤掉未找到的项
};

// 这个函数接受一个label数组，返回对应的value数组，然后转换成以逗号隔开的字符串
export const destSpeciFindValues = (labels) => {
  let specList = [
    {
      value: "3",
      label: "INSIDEDELIVERY",
    },
    {
      value: "4",
      label: "LIFTGATEREQUIRED",
    },
    {
      value: "5",
      label: "APPOINTMENTFEE",
    },
  ];
  const values = labels
    .map((label) => {
      const item = specList.find((item) => item.label === label);
      return item ? item.value : null;
    })
    .filter((value) => value !== null); // 过滤掉未找到的项
  return values.join(","); // 将数组转换成以逗号隔开的字符串
};
/*
 **  经销商筛选数据1
 **  attr:根据该属性排序；rev:升序1或降序-1，不填默认1
 */
export const sortBy = (attr, rev) => {
  if (rev == undefined) {
    rev = 1;
  } else {
    rev ? 1 : -1;
  }
  return function (a, b) {
    a = a[attr];
    b = b[attr];
    if (a < b) {
      return rev * -1;
    }
    if (a > b) {
      return rev * 1;
    }
    return 0;
  };
};

// 经销商筛选数据2
export const filterData = (list, num) => {
  let newlist = [];
  if (num < 4) {
    list.forEach((item) => {
      if (item.carrierTransitDays == num) {
        newlist.push(item);
      }
    });
  } else {
    list.forEach((item) => {
      if (item.carrierTransitDays >= num) {
        newlist.push(item);
      }
    });
  }
  return newlist;
};

// 创建快递面单读取最后可用时间
export const findTimeIndex = (list,startTime) => {
  let index = list.indexOf(startTime);
  if (index !== -1) {
    return list.slice(index);
  }
  return []; // 如果找不到时间，返回null
}

const US_PICKUP_TIMEZONE_BY_STATE = {
  AL: "America/Chicago",
  ALABAMA: "America/Chicago",
  AK: "America/Anchorage",
  ALASKA: "America/Anchorage",
  AZ: "America/Phoenix",
  ARIZONA: "America/Phoenix",
  AR: "America/Chicago",
  ARKANSAS: "America/Chicago",
  CA: "America/Los_Angeles",
  CALIFORNIA: "America/Los_Angeles",
  CO: "America/Denver",
  COLORADO: "America/Denver",
  CT: "America/New_York",
  CONNECTICUT: "America/New_York",
  DE: "America/New_York",
  DELAWARE: "America/New_York",
  DC: "America/New_York",
  "DISTRICT OF COLUMBIA": "America/New_York",
  FL: "America/New_York",
  FLORIDA: "America/New_York",
  GA: "America/New_York",
  GEORGIA: "America/New_York",
  HI: "Pacific/Honolulu",
  HAWAII: "Pacific/Honolulu",
  ID: "America/Denver",
  IDAHO: "America/Denver",
  IL: "America/Chicago",
  ILLINOIS: "America/Chicago",
  IN: "America/Indiana/Indianapolis",
  INDIANA: "America/Indiana/Indianapolis",
  IA: "America/Chicago",
  IOWA: "America/Chicago",
  KS: "America/Chicago",
  KANSAS: "America/Chicago",
  KY: "America/New_York",
  KENTUCKY: "America/New_York",
  LA: "America/Chicago",
  LOUISIANA: "America/Chicago",
  ME: "America/New_York",
  MAINE: "America/New_York",
  MD: "America/New_York",
  MARYLAND: "America/New_York",
  MA: "America/New_York",
  MASSACHUSETTS: "America/New_York",
  MI: "America/Detroit",
  MICHIGAN: "America/Detroit",
  MN: "America/Chicago",
  MINNESOTA: "America/Chicago",
  MS: "America/Chicago",
  MISSISSIPPI: "America/Chicago",
  MO: "America/Chicago",
  MISSOURI: "America/Chicago",
  MT: "America/Denver",
  MONTANA: "America/Denver",
  NE: "America/Chicago",
  NEBRASKA: "America/Chicago",
  NV: "America/Los_Angeles",
  NEVADA: "America/Los_Angeles",
  NH: "America/New_York",
  "NEW HAMPSHIRE": "America/New_York",
  NJ: "America/New_York",
  "NEW JERSEY": "America/New_York",
  NM: "America/Denver",
  "NEW MEXICO": "America/Denver",
  NY: "America/New_York",
  "NEW YORK": "America/New_York",
  NC: "America/New_York",
  "NORTH CAROLINA": "America/New_York",
  ND: "America/Chicago",
  "NORTH DAKOTA": "America/Chicago",
  OH: "America/New_York",
  OHIO: "America/New_York",
  OK: "America/Chicago",
  OKLAHOMA: "America/Chicago",
  OR: "America/Los_Angeles",
  OREGON: "America/Los_Angeles",
  PA: "America/New_York",
  PENNSYLVANIA: "America/New_York",
  RI: "America/New_York",
  "RHODE ISLAND": "America/New_York",
  SC: "America/New_York",
  "SOUTH CAROLINA": "America/New_York",
  SD: "America/Chicago",
  "SOUTH DAKOTA": "America/Chicago",
  TN: "America/Chicago",
  TENNESSEE: "America/Chicago",
  TX: "America/Chicago",
  TEXAS: "America/Chicago",
  UT: "America/Denver",
  UTAH: "America/Denver",
  VT: "America/New_York",
  VERMONT: "America/New_York",
  VA: "America/New_York",
  VIRGINIA: "America/New_York",
  WA: "America/Los_Angeles",
  WASHINGTON: "America/Los_Angeles",
  WV: "America/New_York",
  "WEST VIRGINIA": "America/New_York",
  WI: "America/Chicago",
  WISCONSIN: "America/Chicago",
  WY: "America/Denver",
  WYOMING: "America/Denver",
  AS: "Pacific/Pago_Pago",
  "AMERICAN SAMOA": "Pacific/Pago_Pago",
  GU: "Pacific/Guam",
  GUAM: "Pacific/Guam",
  MP: "Pacific/Saipan",
  "NORTHERN MARIANA ISLANDS": "Pacific/Saipan",
  PR: "America/Puerto_Rico",
  "PUERTO RICO": "America/Puerto_Rico",
  VI: "America/St_Thomas",
  "VIRGIN ISLANDS, U.S.": "America/St_Thomas",
};

const normalizePickupKey = (value) => String(value || "").trim().toUpperCase();

export const getPickupTimeZone = (country, province) => {
  const countryKey = normalizePickupKey(country);
  const isUnitedStates = !countryKey || ["UNITED STATES", "US", "USA", "U.S.", "U.S.A."].includes(countryKey);
  if (isUnitedStates) {
    return US_PICKUP_TIMEZONE_BY_STATE[normalizePickupKey(province)] || "UTC";
  }

  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (e) {
    return "UTC";
  }
};

const datePartsInTimeZone = (date, timeZone) => {
  const d = date instanceof Date ? date : new Date(date);
  try {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    });
    const parts = formatter.formatToParts(d).reduce((result, part) => {
      result[part.type] = part.value;
      return result;
    }, {});
    return {
      year: parts.year,
      month: parts.month,
      day: parts.day,
      hour: Number(parts.hour || 0) % 24,
      minute: Number(parts.minute || 0),
    };
  } catch (e) {
    return {
      year: String(d.getFullYear()),
      month: String(d.getMonth() + 1).padStart(2, "0"),
      day: String(d.getDate()).padStart(2, "0"),
      hour: d.getHours(),
      minute: d.getMinutes(),
    };
  }
};

export const formatPickupDateValue = (value) => {
  if (!value) return "";
  if (value instanceof Date) {
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`;
  }
  const text = String(value).trim();
  if (!text) return "";
  if (text.indexOf("T") !== -1) {
    const isoDate = text.match(/^(\d{4}-\d{2}-\d{2})T/);
    if (isoDate) return isoDate[1];
  }
  const match = text.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
  if (match) {
    return `${match[1]}-${String(match[2]).padStart(2, "0")}-${String(match[3]).padStart(2, "0")}`;
  }
  const parsed = new Date(text);
  if (!Number.isNaN(parsed.getTime())) {
    return formatPickupDateValue(parsed);
  }
  return text;
};

export const getPickupTodayValue = (country, province) => {
  const parts = datePartsInTimeZone(new Date(), getPickupTimeZone(country, province));
  return `${parts.year}-${parts.month}-${parts.day}`;
};

export const getPickupNowMinutes = (country, province) => {
  const parts = datePartsInTimeZone(new Date(), getPickupTimeZone(country, province));
  return parts.hour * 60 + parts.minute;
};

export const isPickupDateBeforeToday = (value, country, province) => {
  const dateValue = formatPickupDateValue(value);
  if (!dateValue) return false;
  return dateValue < getPickupTodayValue(country, province);
};

export const parsePickupTimeToMinutes = (value) => {
  const match = String(value || "").trim().toLowerCase().match(/^(\d{1,2}):(\d{2})\s*(am|pm)$/);
  if (!match) return null;
  let hour = parseInt(match[1], 10);
  const minute = parseInt(match[2], 10);
  if (match[3] === "am") {
    if (hour === 12) hour = 0;
  } else if (hour !== 12) {
    hour += 12;
  }
  return hour * 60 + minute;
};
